import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

import { BidNotificationInfo, BmDataAccessFacade } from '@nexweb/shared/data-access/bm';

import { RequestExtensionOfActivationPeriod } from '../../../models';
import { RequestExtensionOfActivationPeriodService } from '../../../services';
import { ExtensionFormComponent } from '../extension-form/extension-form.component';

@Component({
  selector: 'nexweb-ext-sup-bsp-not',
  templateUrl: './ext-sup-bsp-not.component.html',
  imports: [AsyncPipe, ExtensionFormComponent],
})
export class ExtSupBspNotComponent implements OnInit {
  @Input() bidId: number;

  public extension$: Observable<RequestExtensionOfActivationPeriod.ActivationExtension>;
  public dateTimeFormat: string;
  public labels: RequestExtensionOfActivationPeriod.Labels;
  public headings: RequestExtensionOfActivationPeriod.Headings;

  private bmFacade = inject(BmDataAccessFacade);
  private requestExtensionOfActivationService = inject(RequestExtensionOfActivationPeriodService);

  ngOnInit(): void {
    this.labels = this.requestExtensionOfActivationService.getNotificationLabels();
    this.headings = this.requestExtensionOfActivationService.getNotificationHeadings();
    this.dateTimeFormat = this.requestExtensionOfActivationService.getDateTimeFormat();

    this.initialiseData();
  }

  private initialiseData(): void {
    this.extension$ = this.bmFacade.getBidNotificationInfo(this.bidId).pipe(
      map((bidNotificationInfo: BidNotificationInfo) => {
        const bidNotificationData = {
          name: bidNotificationInfo.requestingTsoName,
          telephoneNumber: bidNotificationInfo.requestingTsoPhoneNumber,
          portfolio: bidNotificationInfo.requestingTsoPortfolioName,
          requestedQuantity: bidNotificationInfo.requestedQuantity,
          instrument: bidNotificationInfo.instrument,
          requestedActivationTime: bidNotificationInfo.requestFullDispatchTime,
        } as RequestExtensionOfActivationPeriod.ActivationExtension;

        return bidNotificationData;
      }),
    );
  }
}
